import {
  GetConversation,
  UserConversationContainer,
} from '@/client/services/api/graphql/gql/graphql';

import { archiveUserAIConversationMutation } from './mutations/archiveUserAIConversationMutation';
import { getUserAIConversationByIdQuery } from '@/client/components/ai-agent/v2/api/queries/getUserAIConversationByIdQuery';
import { graphQLClient } from '@/client/services/api/clients/graphqlClient';
import { listUserAIConversationsQuery } from '@/client/components/ai-agent/v2/api/queries/listUserAIConversationsQuery';

const getUserConversations = async (searchTerm?: string): Promise<UserConversationContainer> => {
  let payload = {};

  if (searchTerm) {
    payload = { search: { contains: searchTerm } };
  }

  const data: any = await graphQLClient.request(listUserAIConversationsQuery, payload);

  return data.listUserConversations;
};

const getUserAIConversationById = async (id: string): Promise<GetConversation[]> => {
  const data: any = await graphQLClient.request(getUserAIConversationByIdQuery, { id });

  return data.getConversation;
};

const archiveUserAIConversation = async (conversationId: string): Promise<boolean> => {
  const data: any = await graphQLClient.request(archiveUserAIConversationMutation, {
    conversationId,
  });

  return data.archiveConversation;
};

const AIAgentService = {
  getUserConversations,
  getUserAIConversationById,
  archiveUserAIConversation,
};

export default AIAgentService;
